import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Screenshot = makeShortcode("Screenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`About audit reports`}</h1>
    <p>{`Audit reports contain tables of information about security vulnerabilities in your project's dependencies to help you fix the vulnerability or troubleshoot further.`}</p>
    <Screenshot src="/packages-and-modules/securing-your-code/audit-report-results.png" alt="Screenshot showing command-line audit report results" mdxType="Screenshot" />
    <h2>{`Vulnerability table fields`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#severity"
        }}>{`Severity`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#description"
        }}>{`Description`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#package"
        }}>{`Package`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#patched-in"
        }}>{`Patched in`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#dependency-of"
        }}>{`Dependency of`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#path"
        }}>{`Path`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#more-info"
        }}>{`More info`}</a></li>
    </ul>
    <h3>{`Severity`}</h3>
    <p>{`The severity of the vulnerability, determined by the impact and exploitability of the vulnerability in its most common use case.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Severity`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Recommended action`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Critical`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Address immediately`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`High`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Address as quickly as possible`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Moderate`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Address as time allows`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Low`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Address at your discretion`}</td>
        </tr>
      </tbody>
    </table>
    <h4>{`Description`}</h4>
    <p>{`The description of the vulnerability. For example, "Denial of service".`}</p>
    <h4>{`Package`}</h4>
    <p>{`The name of the package that contains the vulnerability.`}</p>
    <h4>{`Patched in`}</h4>
    <p>{`The semantic version range that describes which versions contain a fix for the vulnerability.`}</p>
    <h4>{`Dependency of`}</h4>
    <p>{`The module that the package with the vulnerability depends on.`}</p>
    <h4>{`Path`}</h4>
    <p>{`The path to the code that contains the vulnerability.`}</p>
    <h4>{`More info`}</h4>
    <p>{`A link to the security report.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      